
export default class Media {
  constructor({ media, index, carouselSize, loop, gap }) {

    this.media = media
    this.index = index
    this.loop = loop || false
    this.gap = gap || 0
    this.screen = {
      width: window.innerWidth,
      height: window.innerHeight
    }
    //    
    this.onResize(carouselSize)
  }

  updateX(x = 0) {
    this.media.style.left = (x + this.extraX) + 'px'
  }

  updateY(y = 0) {
    this.media.style.top = (y + this.extraY) + 'px'
  }

  onResize(carouselSize) {
    this.extraX = 0
    this.extraY = 0
    this.carouselSize = carouselSize
  }

  update(scroll, direction) {
    // console.log(scroll,direction)    
    this.updateX(scroll.current)
    // this.updateY(scroll.current)  
    // 
    if (this.loop) {

      let isAfter = this.media.offsetLeft + 220 > window.innerWidth
      let isBefore = this.media.offsetLeft + this.media.clientWidth + 220 < 0

      if (direction === 'right' && isAfter) {
        this.extraX -= this.carouselSize.width
        isBefore = isAfter = false
      }

      if (direction === 'left' && isBefore) {
        this.extraX += this.carouselSize.width
        isBefore = isAfter = false
      }

    }

  }

}